import { StatusCodes } from "http-status-codes";
import { ILoginResponse, ILoginCredentials } from "../interfaces/IAuth";
import { AUTH_APIS } from "../utils/constants";
import Axios from "../utils/axiosInterceptor";

import axios from "axios";
import { errorMessage } from "../utils/notificationUtils";
import { errorMessageModal } from "../utils/modalMessage";
export const login = async (
  credentials: ILoginCredentials
): Promise<ILoginResponse> => {
  try {
    const response = await Axios.post(AUTH_APIS.LOGIN, credentials);

    if (response.status === StatusCodes.OK) {
      return {
        authData: response.data,
        status: response.status,
      };
    } else {
      return {
        authData: response.data.message,
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error in Log In:", error);
    throw new Error("Error in Log In, Please try again");
  }
};

export const fetchServerTime = async (
  access_token: string | null
): Promise<string> => {
  try {
    const response = await Axios.get<string>(AUTH_APIS.SERVER_TIME, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching server time:", error);
    return new Date().toString();
  }
};

export const logout = async (): Promise<void> => {
  try {
    await Axios.post(AUTH_APIS.LOGOUT);
  } catch (error) {
    console.error("Error in Logging Out:", error);
    throw new Error("Error in Logging Out, Please try again");
  }
};

//Portal Authentication
export const portalLogin = async (hospitalId: number) => {
  try {
    const response = await Axios.post(
      `${AUTH_APIS.PORTAL_AUTH}/${hospitalId}/login`
    );

    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      errorMessageModal(response.data.message);
      return "";
    }
  } catch (error) {
    console.error("Error in Portal Log In:", error);
    throw new Error("Error in Portal Log In, Please try again");
  }
};
export const portalLogout = async (hospitalId: number) => {
  try {
    const response = await Axios.post(
      `${AUTH_APIS.PORTAL_AUTH}/${hospitalId}/logout`
    );

    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      errorMessageModal(response.data.message);
    }
  } catch (error) {
    console.error("Error in Portal Log Out:", error);
    throw new Error("Error in Portal Log Out, Please try again");
  }
};
export const portalSaveOtp = async (hospitalId: number, otp: string) => {
  try {
    const response = await Axios.post(
      `${AUTH_APIS.PORTAL_AUTH}/${hospitalId}/saveOtp/${otp}`
    );

    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      errorMessageModal(response.data.message);
    }
  } catch (error) {
    console.error("Error in OTP Log in:", error);
    throw new Error("Error in OTP Log in, Please try again");
  }
};

//Portal Login APIs
export const portalsLogin = async (data: any, portalId: any) => {
  try {
    const response = await Axios.post(
      `${AUTH_APIS.PORTAL_LOGIN}/${portalId}/login/initiate`,
      data
    );

    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      errorMessageModal(response.data.message);
      return "";
    }
  } catch (error: any) {
    console.error("Error in Portal Log In:", error);
    throw new Error(
      typeof error?.response?.data === "string"
        ? error?.response?.data
        : "Error in Portal Log In, Please try again"
    );
  }
};
export const portalsLogout = async (data: any, portalId: any) => {
  try {
    const response = await Axios.post(
      `${AUTH_APIS.PORTAL_LOGOUT}/${portalId}/logout/initiate`,
      data
    );

    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      errorMessageModal(response.data.message);
    }
  } catch (error: any) {
    console.error("Error in Portal Log Out:", error);
    throw new Error(
      typeof error?.response?.data === "string"
        ? error?.response?.data
        : "Error in Portal Log Out, Please try again"
    );
  }
};
export const checkLoginSession = async (data: any) => {
  try {
    const response = await Axios.post(`${AUTH_APIS.CHECK_LOGIN_SESSION}`, data);

    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      errorMessageModal(response.data.message);
    }
  } catch (error: any) {
    console.error("Error in Checking Login Session:", error);
    throw new Error(
      typeof error?.response?.data === "string"
        ? error?.response?.data
        : "Error in Checking Login Session, Please try again"
    );
  }
};

export const portalsSaveOtp = async (data: any, portalId: any) => {
  try {
    const response = await Axios.post(
      `${AUTH_APIS.PORTAL_OTP}/${portalId}/saveOtp`,
      data
    );

    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      errorMessageModal(response.data.message);
    }
  } catch (error: any) {
    console.error("Error in OTP Log in:", error);
    throw new Error(
      typeof error?.response?.data === "string"
        ? error?.response?.data
        : "Error in OTP Log in, Please try again"
    );
  }
};

export const getCaptcha = async (data: any, portalId: any) => {
  try {
    const response = await Axios.post(
      `${AUTH_APIS.CAPTCHA_PORTAL}/${portalId}/captcha`,
      data
    );

    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      errorMessageModal(response?.data?.message);
    }
  } catch (error: any) {
    console.error("Error in Getting Captcha:", error);
    throw new Error(
      typeof error?.response?.data === "string"
        ? error?.response?.data
        : "Error in Getting Captcha, Please try again"
    );
  }
};

export const getLiveScreen = async (data: any, portalId: any) => {
  try {
    const response = await Axios.post(
      `${AUTH_APIS.LIVE_SCREEN_PORTAL}/${portalId}/screenShot`,
      data
    );

    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      errorMessageModal(response?.data?.message);
    }
  } catch (error: any) {
    console.error("Error in Getting Live Screen:", error);
    throw new Error(
      typeof error?.response?.data === "string"
        ? error?.response?.data
        : "Error in Getting Live Screen, Please try again"
    );
  }
};

export const portalsLoginRetry = async (data: any) => {
  try {
    const response = await Axios.post(
      `${AUTH_APIS.LOGIN_RETRY}`,
      data
    );

    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      errorMessageModal(response.data.message);
      return "";
    }
  } catch (error: any) {
    console.error("Error in Retry:", error);
    throw new Error(
      typeof error?.response?.data === "string"
        ? error?.response?.data
        : "Error in Retry, Please try again"
    );
  }
};
